/**
 *
 * FormField
 *
 */

import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faCheck } from '@fortawesome/free-solid-svg-icons'

import "./style.scss";

/* eslint-disable react/prefer-stateless-function */
export class InlineAlert extends React.PureComponent {
  render() {
    return <div className="inline alert"><span className="icon"><FontAwesomeIcon icon={faExclamationTriangle} size="1x"/></span> {this.props.children} </div>
  }
}

/* eslint-disable react/prefer-stateless-function */
export class Alert extends React.PureComponent {
  render() {
    return <div className="alert"><span className="icon"><FontAwesomeIcon icon={faExclamationTriangle} size="1x"/></span> {this.props.children} </div>
  }
}

/* eslint-disable react/prefer-stateless-function */
export class InlineWarning extends React.PureComponent {
  render() {
    return <div className="inline warning"><span className="icon"><FontAwesomeIcon icon={faExclamationTriangle} size="1x"/></span> {this.props.children} </div>
  }
}

/* eslint-disable react/prefer-stateless-function */
export class Warning extends React.PureComponent {
  render() {
    return <div className="warning"><span className="icon"><FontAwesomeIcon icon={faExclamationTriangle} size="1x"/></span> {this.props.children} </div>
  }
}

/* eslint-disable react/prefer-stateless-function */
export class InlineSuccess extends React.PureComponent {
  render() {
    return <div className="inline success"><span className="icon"><FontAwesomeIcon icon={faCheck} size="1x"/></span> {this.props.children} </div>
  }
}